import React from 'react';

/**
 * Step 1 — capture the basics of the user's goal/project.
 *
 * Props:
 *   basics:       current basics state object
 *   onChange:     (field) => (event|value) => void
 *   basicsValid:  boolean
 *   loading:      boolean (shown on the primary CTA)
 *   onCancel:     () => void
 *   onNext:       () => void
 */
export default function BasicsStep({
  basics,
  onChange,
  basicsValid,
  loading,
  onCancel,
  onNext,
}) {
  return (
    <section className="goal-step">
      <h2>What do you want to learn or build?</h2>
      <p className="goal-step-hint">
        Tell us the basics. We&apos;ll ask a couple of follow-ups, then draft a
        multi-month plan you can review and edit.
      </p>

      <label className="goal-field">
        <span>Goal title</span>
        <input
          type="text"
          value={basics.title}
          onChange={onChange('title')}
          placeholder='e.g. "Learn conversational Spanish" or "Build a backyard shed"'
          maxLength={150}
          autoFocus
        />
      </label>

      <label className="goal-field">
        <span>Type</span>
        <select value={basics.category} onChange={onChange('category')}>
          <option value="learning">Learning goal</option>
          <option value="project">Project</option>
          <option value="sport_course">Sport/Course</option>
        </select>
      </label>

      <div className="goal-field-row">
        <label className="goal-field">
          <span>Target completion date</span>
          <input
            type="date"
            value={basics.targetDate}
            onChange={onChange('targetDate')}
            min={new Date().toISOString().slice(0, 10)}
          />
        </label>
        <label className="goal-field">
          <span>Hours per week</span>
          <input
            type="number"
            min={1}
            max={40}
            value={basics.weeklyHours}
            onChange={onChange('weeklyHours')}
          />
        </label>
      </div>

      <label className="goal-field">
        <span>Current level / experience</span>
        <input
          type="text"
          value={basics.currentLevel}
          onChange={onChange('currentLevel')}
          placeholder='e.g. "complete beginner", "built one before", "intermediate runner"'
          maxLength={200}
        />
      </label>

      <label className="goal-field">
        <span>Why this goal? (optional)</span>
        <textarea
          rows={3}
          value={basics.motivation}
          onChange={onChange('motivation')}
          placeholder="Motivation, constraints, what success looks like…"
          maxLength={500}
        />
      </label>

      <div className="goal-actions">
        <button type="button" className="goal-btn-secondary" onClick={onCancel}>
          Cancel
        </button>
        <button
          type="button"
          className="goal-btn-primary"
          onClick={onNext}
          disabled={!basicsValid || loading}
        >
          {loading ? 'Thinking…' : 'Next: attachments →'}
        </button>
      </div>
    </section>
  );
}
